import Diferenciais from './Diferenciais';

export default Diferenciais;
